export const typography = {
  baseFontSize: '12px',
  baseFontFamily:
    '-apple-system, BlinkMacSystemFont, Segoe UI, Arial, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
  lineHeight: '1.2rem'
};
